import { faChevronRight } from '@fortawesome/pro-light-svg-icons'
import { CustomerProjectModelType } from '@teinor/erp/types/company/customer/customerProject'
import { QuoteOrderModelType } from '@teinor/erp/types/company/order/quote/quoteOrder'
import { useCallback, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { RenderQuoteStatus } from '../../../../app/erp/screens/Logistic/QuoteParent/subcomponents'
import { DisplayPriceGettingParams } from '../../../../baseComponents/Displays/DisplayPrice'
import TwinIcon from '../../../../baseComponents/TwinIcon'
import { VirtualTableListingStateLess } from '../../../../baseComponents/TwinTable/VirtualTableListing'
import { CustomRenderDate, CustomRenderString } from '../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import { twinFetchPostJSON } from '../../../../utils/globals/data'
import useTwinTranslation from '../../../../utils/hooks/useTwinTranslation'
import TwinTrans from '../../../../baseComponents/TwinTrans'
import useEditDeleteModal from '../../../../utils/hooks/useEditDeleteModal'
import ModalCustomerProjectCreateQuote from './ModalCustomerProjectCreateQuote'
import locations from '../../../../utils/globals/locations'

interface CustomerProjectQuoteTabProps extends CustomerProjectQuoteTabLogicProps {
    getData: () => Promise<void>
}

const CustomerProjectQuoteTab: React.FC<CustomerProjectQuoteTabProps> = ({ customerProjectData, getData }) => {
    const { quotes, setOpenModal, openModal } = useCustomerProjectQuoteTabLogic({ customerProjectData })
    const { t } = useTwinTranslation()
    const columns: ColumnTableSchema<QuoteOrderModelType> = [
        {
            id: 'full_assigned_number',
            dataKey: 'full_assigned_number',
            label: t('orderQuoteP', 'Pedido'),
            customRender: (parameterValue, allRowData) => <CustomRenderString value={parameterValue} className={allRowData?.assigned_number ? '' : 'text-red-BA'} />,
        },
        {
            id: 'version',
            dataKey: 'version',
            label: t('version', 'Versión'),
            width: 90,
            customRender: (parameterValue, allRowData) => <CustomRenderString value={parameterValue || allRowData.version} />,
        },
        {
            id: 'status',
            dataKey: 'status',
            label: t('status', 'Estado'),
            minWidth: 120,
            customRender: (parameterValue) => <RenderQuoteStatus value={parameterValue} />,
        },
        {
            id: 'WorkingCenterId',
            dataKey: 'WorkingCenterId',
            searchKey: 'WorkingCenter.name',
            label: t('workingCenter', 'Centro de trabajo'),
            customRender: (_parameterValue, allRowData) => <CustomRenderString value={allRowData?.WorkingCenter?.name || ''} />
        },
        {
            id: 'processed_date',
            dataKey: 'processed_date',
            label: t('createdDate', 'Fecha de creación'),
            customRender: (parameterValue, allRowData) => <CustomRenderDate value={parameterValue || allRowData.createdAt} className={parameterValue ? '' : 'text-red-BA'} />,
            minWidth: 180,
        },
        {
            id: 'total_total',
            dataKey: 'total_total',
            label: t('total', 'Total'),
            customRender: (parameterValue, allRowData) => allRowData?.hidePrices ? <div>-</div> : <DisplayPriceGettingParams value={parseFloat(parameterValue)} with_vat={allRowData.with_vat} CurrencyId={allRowData.CurrencyId} />,
        },
        {
            id: 'arrow',
            dataKey: 'id',
            label: '',
            width: 50,
            customRender: (parameterValue, allRowData) =>
                <Link to={locations.quoteOrderSingle + '/' + parameterValue}><TwinIcon icon={faChevronRight} /></Link>
        },
    ]
    return (
        <div className='flex flex-col flex-auto gap-20 customer_project_quote_tab'>
            <div className='flex'>
                <button className='text-green-43 mt-20 ml-auto' onClick={() => setOpenModal({ type: 'create', allRowData: customerProjectData })}><TwinTrans transKey='addQuote'>Agregar presupuesto</TwinTrans></button>
            </div>
            <VirtualTableListingStateLess tableData={quotes} columns={columns} setSelectedColumnsAndFilters={() => { }} name={'CustomerProjectQuoteTabTable'} />
            {openModal?.type === 'create' ? <ModalCustomerProjectCreateQuote allRowData={openModal.allRowData} setOpened={() => setOpenModal(null)} onSubmit={getData} /> : null}
        </div>
    )
}

interface CustomerProjectQuoteTabLogicProps {
    customerProjectData: CustomerProjectModelType
}

const useCustomerProjectQuoteTabLogic = ({ customerProjectData }: CustomerProjectQuoteTabLogicProps) => {
    const { openModal, setOpenModal } = useEditDeleteModal()
    const [quotes, setQuotes] = useState<QuoteOrderModelType[] | null>(null)
    const getQuotesData = useCallback(async () => {
        const result = await twinFetchPostJSON('/api/app/order/quote/getAllQuoteOrdersComplete', {
            where: {
                CustomerProjectId: customerProjectData.id,
                is_last: true
            }
        })
        if (result) {
            setQuotes(result)
        }
    }, [setQuotes, customerProjectData.id])

    useEffect(() => {
        getQuotesData()
    }, [getQuotesData])

    return { quotes, getQuotesData, setOpenModal, openModal }
}

export default CustomerProjectQuoteTab